/* eslint-disable @typescript-eslint/naming-convention */
const csvToArray = (value: string): string[] => {
  return (value || '')
    .split(',')
    .map((val) => val.trim())
    .filter((val) => !!val);
};

export default csvToArray;
